export default "__VITE_ASSET__6be1889a__"